import styled from 'styled-components'
import { Switch } from 'antd'
import LiveModal from 'live/components/ui/Modal'

export const Label = styled.span`
    font-weight: 600;
    font-size: 10px;
    line-height: 16px;
    margin-bottom: 4px;
    margin-right: 5px;
    .metric {
        font-style: normal;
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
        color: var(--blue-500);
    }
`

export const UnitLabel = styled.span`
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 16px;
    color: var(--gray-600);
`

export const StyledSwitch = styled(Switch)`
    min-width: 32px !important;
`

export const ChannelsConfigBody = styled.div`
    background-color: white;
    padding: 30px;
`

export const ChannelsConfigFooter = styled.div`
    display: flex;
    justify-content: flex-start;
    padding: 1.5rem 2.5rem;
    border-top: 1px solid lightgray;

    button {
        font-weight: bold;
    }

    button {
        &:first-child {
            margin-right: 0.5rem;
        }
    }
`

export const CustomWellModal = styled(LiveModal)`
    .modal-dialog {
        width: 430px;
    }
`

export const ChannelsConfigRigFloorContainer = styled.div`
    margin-top: 100%;
    min-width: 430px;

    .modal-title {
        padding: 0 2.5rem;
        color: var(--blue-700);
        display: flex;
        gap: 0.5rem;
        align-items: center;
        background: var(--gray-0);

        &.__has-close-btn {
            justify-content: space-between;
            gap: initial;
        }
    }

    .modal-body {
        padding: 1.5rem 2.5rem;
        font-size: 1rem;
        color: var(--gray-900);
    }

    .channels-config-rig-floor-modal-footer {
        display: flex;
        justify-content: flex-end;
        padding: 1.5rem 2.5rem;

        button {
            &:first-child {
                margin-right: 0.5rem;
            }
        }
    }
`

export const WellModalContainer = styled.div`
    margin-top: 100%;
    min-width: 430px;
    .modal-title {
        padding: 0 2.5rem;
        color: var(--red-700);
        display: flex;
        gap: 0.5rem;
        align-items: center;
        background: var(--gray-0);

        &.__has-close-btn {
            justify-content: space-between;
            gap: initial;
        }
    }

    .modal-body {
    }

    .modal-footer {
        button {
            &:first-child {
                margin-right: 0.5rem;
            }
        }
    }

    .channels-config-rig-floor-modal-footer {
        background-color: red;
        padding: 20px;
    }
`

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 864px;

    gap: 16px;

    .action-btn-section > div {
        margin-right: -22px;
    }
`

export const Section = styled.section`
    display: flex;
    flex-direction: column;
    flex: 1;

    .live-select {
        width: 100% !important;
        max-width: 100% !important;
    }

    .last-started-status,
    .section-status {
        display: flex;
        align-items: center;
        height: 36px;

        gap: 4px;
    }

    .last-started-status {
        font-size: 11px;
        font-style: normal;
    }

    .section-status {
        font-size: 13px;
        gap: 0;
    }

    .section-name {
        margin-left: -22px;
        margin-right: -10px;
        padding-left: 22px;
    }

    @media only screen and (max-width: 1146px) {
        .section-name {
            padding: 4px 0 4px 22px;
        }
    }

    @media only screen and (max-width: 1100px) {
        .last-started-status {
            font-size: 9px;
        }
    }
`

// Riser Equipments only has 2 equipment selects instead of Rig Floor Equipments' 3, so its row has
// one fewer flex: 1 Section. Without a fixed width here, splitting the remaining space evenly
// across all 3 Sections would make "Riser channels config" narrower than "Rig Floor channels
// config" and shift it out of column alignment. Pinning it to what a 4-column row's share would be
// (matching the other rows' math: 3 gaps of 16px across 4 equal columns) keeps it aligned, while
// RRT/Catwalk — still flex: 1 — grow to fill the freed space instead of leaving it empty.
export const FixedWidthConfigSection = styled(Section)`
    flex: 0 0 calc((100% - 48px) / 4);
`

export const SectionRow = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 16px;

    .section-name {
        display: flex;
        align-items: center;
        gap: 4px;
        height: 20px;

        span,
        label {
            font-size: 13px;
            line-height: 16px;
            font-weight: 600;

            &.interpolation-status {
                font-family: 'SourceSansPro-Bold', Arial, 'Helvetica Neue', Helvetica, sans-serif;
                font-weight: 700;
                padding-bottom: 0;

                .status-on {
                    color: var(--green-700);
                }
                .status-off {
                    color: var(--red-700);
                }
            }
        }

        &.btn.btn-ghost {
            width: 90px;
            border-color: var(--gray-300);
            background-color: var(--gray-300);
        }
    }

    &.section-row-bottom {
        border: 1px solid var(--gray-300);
        padding: 17px;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`

export const CalendarButton = styled.button`
    background-color: transparent;
    height: 36px;
    width: 260px;
    cursor: pointer;
    border: 1px solid var(--gray-400);
    border-radius: 4px;

    &:disabled {
        background-color: var(--gray-200);

        i,
        span {
            color: var(--gray-600) !important;
        }
    }

    .btn-content {
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
            font-size: 13px;
            font-weight: 400;
        }
    }

    @media only screen and (max-width: 1375px) {
        width: 225px;
    }

    @media only screen and (max-width: 1363px) {
        width: 158px;
    }
`

export const ReprocessCalendarModalContainer = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`

export const ModalContent = styled.div`
    background: ${({ theme }) => theme['white']};

    header {
        display: flex;
        align-items: center;
        padding: 12px 24px;

        border-bottom: 1px solid ${({ theme }) => theme['input-borders']};

        span {
            font-size: 18px;
            line-height: 24px;
        }
    }

    footer {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 7px 24px;

        .btn-cancel {
            border: 1px solid ${({ theme }) => theme['input-borders']};
            padding: 9px 24px;
            font-size: 15px;
            font-weight: 600;
            border-radius: 3px;
            background: transparent;

            &:hover {
                opacity: 0.8;
            }
        }
    }
`

export const ActionBtn = styled.button`
    font-size: 13px;
    font-weight: 600;
    padding: 4px 16px;

    &.btn {
        border-color: #eee;
        color: #37a3ef;

        &:not(.btn-primary):hover {
            background-color: #f1f1f1;
        }

        &.btn-primary:hover {
            background: ${({ theme }) => theme['blue-700']};
        }
    }

    &.btn.btn-primary {
        border-color: #008ac7;
        color: #fff;
    }
    &:focus {
        outline: none;
    }
`

export const Actions = styled.div`
    padding: 20px 0px 8px 0px;
    display: flex;
`

export const Cancel = styled.a`
    margin-left: 4px;
`

// No margin here on purpose: this renders inside kpis-drilling's MainContainer (a flex column
// with gap: 16px) via ExtensionPoint, so it's flattened as a direct flex sibling of the equipment
// group blocks around it — the parent's gap alone supplies the 16px space on each side. Adding a
// margin here would stack on top of that gap instead of replacing it (RS: was rendering as
// gap + margin, e.g. 16px + 22px, far wider than the Figma-specified 16px).
export const Divisor = styled.div`
    width: calc(100% + 44px);
    margin-left: -22px;
    height: 1px;
    background: var(--gray-300);
`